import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/pwa-192x192.png")